import React from 'react';
import styled from 'styled-components';
import { Typo, Icon } from 'tmt-ui-kit';

import config from '~/config';

const Title = styled(Typo.HeaderOne)`
  width: 70%;
  font-size: 36px !important;
  font-weight: 500 !important;
  text-align: center;
  margin: 0 auto;
  color: ${props => props.theme.white} !important;
  @media(max-width: 600px) {
    width: 80%;
    margin: 0px;
    font-size: 24px !important;
    text-align: left;
  }
`;
const SearchIcon = styled(Icon)`
  font-size: 32px !important;
  color: ${props => props.theme.white};
`;

const SearchButton = styled.button`
  display: none;  
  width: 45px;
  height: 40px;
  border: 0px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: ${props => props.theme.blue};
`;

const InputContainer = styled.div`
  margin: 52px auto 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media(max-width: 600px) {
    margin-top: 12px;
    justify-content: left;
    align-items: flex-start;
  }
`;

const InputBox = styled.input`
  display: none;
  box-sizing: border-box;
  width: 235px;
  height: 40px;
  border: 0px;
  padding-left: 14px;
  padding-right: 4px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.57;
  color: ${props => props.theme.darkBlue};
  background-color: ${props => props.theme.white};
`;

const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: 50%;
  height: 650px;
  position: relative;
  box-sizing: border-box;
  @media(max-width: 1200px) {
    height: 432px;
  }
  @media(max-width: 600px) {
    padding: 28px;
    height: 281px;
    justify-content: left;
    align-items: flex-start;
  }
`;

const BlackOpacity = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, .6), rgba(0, 0, 0, .43) 14%, rgba(0, 0, 0, .3) 28%, rgba(0, 0, 0, .0));
  z-index: 20;
`;

const BannerImage = styled.img`
  position: absolute;
  z-index: 10;
  object-fit: cover;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

const BannerOverlay = styled.div`
  z-index: 20;
  text-align: center;
  @media(max-width: 600px) {
    text-align: left
  }
`;

const BannerTextContainer = styled.div`
  @media(min-width: 601px) and (max-width: 1200px) {
    padding: 24px;
  }
`;

const BannerHelp = () => {
  const bannerTitle = 'Find Your Answers of Traveling Here';
  return (
    <BannerContainer>
      <BlackOpacity />
      <BannerImage src={`${config.assetPath}/static/images/HelpCenter/mask@2x.jpg`} alt={bannerTitle} />
      <BannerOverlay>
        <BannerTextContainer>
          <Title>{bannerTitle}</Title>
          <InputContainer>
            <InputBox name="search" placeholder="What can we help with you ?"/>
            <SearchButton>
              <SearchIcon name="search" />
            </SearchButton>
          </InputContainer>
        </BannerTextContainer>
      </BannerOverlay>
    </BannerContainer>
  );
};

export default BannerHelp;
